export default "__VITE_ASSET__DbLQKM2n__"